import { render, staticRenderFns } from "./WizardEntradaNota.vue?vue&type=template&id=5b4705f3"
import script from "./WizardEntradaNota.vue?vue&type=script&lang=js"
export * from "./WizardEntradaNota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports